import { render, staticRenderFns } from "./IntAstaDxPreview.vue?vue&type=template&id=f08ec1f0"
import script from "./IntAstaDxPreview.vue?vue&type=script&lang=js"
export * from "./IntAstaDxPreview.vue?vue&type=script&lang=js"
import style0 from "./IntAstaDxPreview.vue?vue&type=style&index=0&id=f08ec1f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports